import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMoviesList() {
  // Use toast
  const toast = useToast()

  const refMovieListTable = ref(null)

  const perPage = ref(10)
  const totalMovies = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refMovieListTable.value ? refMovieListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMovies.value,
    }
  })

  const refetchData = () => {
    //refMovieListTable.value.refresh()
    //fetchMovies()
  }

  refetchData()

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchMovies0 = (callback) => {
    store
      .dispatch('movies/fetchMovies', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { movies, total } = response.data

        refMovieListTable.value = movies
        totalMovies.value = total
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching movies list ' + error,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*


  return {
    fetchMovies0,
    perPage,
    currentPage,
    totalMovies,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refMovieListTable,

    refetchData,
  }
}
